import { createContext, useContext, useEffect, useState } from "react";

const KEY = "flexspace.persona";
const NAME_KEY = "flexspace.userName";
const EMAIL_KEY = "flexspace.userEmail";

const PersonaContext = createContext(null);

const DEFAULT_NAMES = {
  developer: "Alex Nguyen",
  designer: "Priya Shah",
  executive: "Marcus Reilly",
  sales: "Jordan Blake",
  field_engineer: "Sam Ortega",
};

export function PersonaProvider({ children }) {
  const [persona, setPersonaState] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; }
  });
  const [userName, setUserName] = useState(() => localStorage.getItem(NAME_KEY) || "");
  const [userEmail, setUserEmail] = useState(() => localStorage.getItem(EMAIL_KEY) || "");

  useEffect(() => {
    if (persona) localStorage.setItem(KEY, JSON.stringify(persona));
  }, [persona]);
  useEffect(() => {
    if (userName) localStorage.setItem(NAME_KEY, userName);
  }, [userName]);
  useEffect(() => {
    if (userEmail) localStorage.setItem(EMAIL_KEY, userEmail);
    else localStorage.removeItem(EMAIL_KEY);
  }, [userEmail]);

  const setPersona = (p) => {
    setPersonaState(p);
    if (p && !userName) setUserName(DEFAULT_NAMES[p.id] || "Employee");
  };

  const clear = () => {
    setPersonaState(null);
    setUserName("");
    setUserEmail("");
    localStorage.removeItem(KEY);
    localStorage.removeItem(NAME_KEY);
    localStorage.removeItem(EMAIL_KEY);
  };

  return (
    <PersonaContext.Provider value={{ persona, setPersona, userName, setUserName, userEmail, setUserEmail, clear }}>
      {children}
    </PersonaContext.Provider>
  );
}

export function usePersona() {
  return useContext(PersonaContext);
}
